import React from 'react';
import useSWR from 'swr';
import nextCookie from 'next-cookies';
import { getRequest } from 'modules/request';
import Chats from 'components/views/private/Settings/Chats';
import jwt from 'jsonwebtoken';
import { useLangContext } from 'components/shared/Lang';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { CabinetLayout } from '../../components/ant/layouts/Cabinet';
import { SingleLayout } from '../../components/ant/layouts';
import SignIn from '../../components/views/auth/SignIn';
import {useAuthContext} from "../../components/shared/Auth";

const fetcher = (url, token) =>
  getRequest()
    .get(url)
    .set('Authorization', `Bearer ${token}`)
    .then((res) => res.body);

const Page = ({ accessToken, chats }) => {
  const { t } = useLangContext();
    const {isAuth, signOut, data, userData} = useAuthContext();

  if (!isAuth) {
    return (
      <SingleLayout title={t('signIn')}>
        <SignIn />
      </SingleLayout>
    );
  }

  return (
    <CabinetLayout>
      {(isAuth && <Chats profile={userData} />) || <>Loading...</>}
    </CabinetLayout>
  );
};

export const getServerSideProps = async (ctx) => {
  ctx.res.setHeader('Cache-Control', 'private, no-store, no-cache, must-revalidate, max-age=0');
  const { accessToken } = nextCookie(ctx);

  return {
    props: {
      ...(await serverSideTranslations(ctx.locale, ['common'])),
      accessToken: accessToken ?? null,
    },
  };
};

export default Page;
